<template>
    <div class="report-result marriage-report-result">
        <!-- 1、二人缘分综合得分 -->
        <div id="mrgBox1" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>二人缘分综合得分</span></div>
                <div class="marriage-content-content">
                    <div class="marriage-content-score-box">
                        <div class="marriage-content-score">
                            <span class="score-num">{{ marriageData.totalScore ? marriageData.totalScore : marriageMergeInfoData.total ? marriageMergeInfoData.total.score : marriageFavorableInfoData ? marriageFavorableInfoData.totalScore : "" }}<span class="score-text">分</span></span>
                        </div>
                        <div class="marriage-content-info" v-if="marriageMergeInfoData && marriageMergeInfoData.total">
                            <span class="info-text" v-for="text in marriageMergeInfoData.total.des">{{ text }}</span>
                        </div>
                    </div>
                    <div class="marriage-content-c-content" v-if="marriageData.is_pay == 0">
                        <div class="marriage-content-c-title">智能月老综合解读：</div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div class="marriage-content-mask1" v-if="marriageData.is_pay == 0 && productData">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div class="marriage-content-c-content" v-if="marriageData.is_pay !== 0 && marriageMergeInfoData && marriageMergeInfoData.total">
                        <div class="marriage-content-c-title">月老综合评定</div>
                        <p class="marriage-content-c-p" v-for="adviceText in marriageMergeInfoData.total.singleAdvice">{{ adviceText }}</p>
                    </div>
                    <div class="marriage-content-c-content" v-if="marriageData.is_pay !== 0">
                        <div class="marriage-content-c-label"><span>月老科普</span></div>
                        <p class="marriage-content-c-p">如果测算的得分很高，说明先天缘分很好，要恭喜二位；但也需要珍惜此缘，后天依然需要好好经营，大事化小，小事化了。而如果测算得分不高或者说很低，那确实只能说明先天缘分不好，但未必不能结合在一起，毕竟感情的事两个人说了算，只要后天方面注意相互理解、包容和支持，先天分数再不济也不能代表结果，现实当中有很多这样的幸福案例，所以要不必介怀，只是在往后的日子里更需要两人齐心协力，每每在发生问题的时候要想到对彼此的承诺或者誓言。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 2、双方生日能量评测 -->
        <div id="mrgBox2" class="marriage-content-box-box">
            <div class="marriage-content-box-border pr">
                <div class="marriage-little-bg little-bg3"></div>
                <div class="marriage-content-title"><span>双方生日能量评测</span></div>
                <marriage-energy-two></marriage-energy-two>
                <div class="marriage-content-c-content marriage-content-c-content2 marriage-content-content-bg">
                    <div class="marriage-content-c-label"><span>常识误区</span></div>
                    <p class="marriage-content-c-p">常识误区：五行缺失，但不代表需要加强，而代表该五行对应的一些天赋能力的缺失，从根本上需要从后天练习来补充。通过佩戴相关颜色或手饰虽然治标不治本但也能起到一定的加分加成作用，考虑到配合运势的助力，建议大家优先选择所喜五行，而不是所缺的五行。</p>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 3、各自的婚姻观 -->
        <div id="mrgBox3" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>各自的婚姻观</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image1"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">这里是二位的先天婚姻观，婚姻观会随着成长环境或者后天教育及成长经历发生一些变化；而且很有意思的是，正常情况下当两个人相处久了，对方会趋向于贴近对方先天婚姻观里的样子，否则就容易产生矛盾。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div class="marriage-content-mask1" v-if="marriageData.is_pay == 0 && productData">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-else class="marriage-content-c-content marriage-content-c-content-bg">
                        <div class="marriage-content-c-content-box bg-male">
                            <div class="marriage-content-c-avatar">
                                <div class="info-avatar avatar-male"></div>
                            </div>
                            <p class="marriage-content-c-p" v-for="text in marriageMaleInfoData.marriageView">{{ text }}</p>
                        </div>
                        <div class="marriage-content-c-content-box bg-female">
                            <div class="marriage-content-c-avatar">
                                <div class="info-avatar avatar-female"></div>
                            </div>
                            <p class="marriage-content-c-p" v-for="text in marriageFemaleInfoData.marriageView">{{ text }}</p>
                        </div>
                        <div class="marriage-content-c-label pad-t-1"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">先天婚姻观方面多数走到一起的夫妇都是不一样的，所以这一项对合婚结果的影响不大，但是作为参考可以做到知己知彼，能够通过沟通交流做到求同存异将有利于感情的长期稳固。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 4、各自夫妻星的稳定性 -->
        <div id="mrgBox4" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>各自夫妻星的稳定性</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image2"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">按照传统的观念来看，夫妻星越稳定越好，而越动荡则代表着婚姻的风险越大，所以古人合婚是必看夫妻星的吉凶状态的。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask1">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-info marriage-content-full dsp-flex">
                            <div class="marriage-content-half bg-male text-center"  v-if="marriageMaleInfoData && marriageMaleInfoData.spouseStar">
                                <div class="marriage-energy-avatar-box box-high avatar-male">
                                    <div class="avatar-content clearfix">
                                        <div class="marriage-energy-avatar avatar-male"></div>
                                        <span class="marriage-energy-nickname">{{ marriageMaleInfoData.name }}</span>
                                    </div>
                                    <div class="avatar-score">得分：<span class="score-text">{{ marriageMaleInfoData.spouseStar.score }}</span></div>
                                </div>
                                <div class="marriage-content-info-bar-box">
                                    <div class="marriage-content-info-bar bar-male"><span class="bar-value" :style="'width: '+marriageMaleInfoData.spouseStar.score+'%;'"></span></div>
                                </div>
                                <p class="marriage-content-c-p" v-for="text in marriageMaleInfoData.spouseStar.des">{{ text }}</p>
                            </div>
                            <div class="marriage-content-half bg-female text-center" v-if="marriageFemaleInfoData && marriageFemaleInfoData.spouseStar">
                                <div class="marriage-energy-avatar-box box-high avatar-female">
                                    <div class="avatar-content clearfix">
                                        <div class="marriage-energy-avatar avatar-female"></div>
                                        <span class="marriage-energy-nickname">{{ marriageFemaleInfoData.name }}</span>
                                    </div>
                                    <div class="avatar-score">得分：<span class="score-text">{{ marriageFemaleInfoData.spouseStar.score }}</span></div>
                                </div>
                                <div class="marriage-content-info-bar-box">
                                    <div class="marriage-content-info-bar bar-female"><span class="bar-value" :style="'width: '+marriageFemaleInfoData.spouseStar.score+'%;'"></span></div>
                                </div>
                                <p class="marriage-content-c-p" v-for="text in marriageFemaleInfoData.spouseStar.des">{{ text }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <p class="marriage-content-c-p">双方分数之间关系：两位分数都较高的话可以理解为吉上加吉，一位较高而另一半较低则会稍稍均衡，如果两位分数都较低的话，就是负向加重出问题的概率，要更加注意；但需强调的是，单项评分由于权重各有差异就算分数再低也不能说明最终等级结果，最终结果以最上面的综合评分为准。</p>
                        <div class="marriage-content-c-label pad-t-1"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">夫妻星越稳定分越高，说明对象越稳定越安静，夫妻星越活跃分越低，说明对象很活跃，动静比较大，但时过境迁，无数大数据案例已经印证了，夫妻星动荡未必代表凶，可以理解为对象是从事动荡比较大的工作，或者出差比较多，只是要注意的是越活跃容易增加，两口子惹事生非的概率。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 5、各自夫妻宫的稳定性 -->
        <div id="mrgBox5" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>各自夫妻宫的稳定性</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image3"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">夫妻宫也是古人合婚的重要指标，古人喜欢夫妻宫安定详和，而现代人相对来说由于社会性质和活动范围发生巨大变化，夫妻宫的不稳定可能表现跟工作等相关，不再一味代表着凶，但依然可作风险规避的参考。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask1">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-info marriage-content-full dsp-flex">
                            <div class="marriage-content-half bg-male text-center" v-if="marriageMaleInfoData && marriageMaleInfoData.palaceStability">
                                <div class="marriage-energy-avatar-box box-high avatar-male">
                                    <div class="avatar-content clearfix">
                                        <div class="marriage-energy-avatar avatar-male"></div>
                                        <span class="marriage-energy-nickname">{{ marriageMaleInfoData.name }}</span>
                                    </div>
                                    <div class="avatar-score">得分：<span class="score-text">{{ marriageMaleInfoData.palaceStability.score }}</span></div>
                                </div>
                                <div class="marriage-content-info-bar-box">
                                    <div class="marriage-content-info-bar bar-male"><span class="bar-value" :style="'width: '+marriageMaleInfoData.palaceStability.score+'%;'"></span></div>
                                </div>
                                <p class="marriage-content-c-p" v-for="text in marriageMaleInfoData.palaceStability.des">{{ text }}</p>
                            </div>
                            <div class="marriage-content-half bg-female text-center" v-if="marriageFemaleInfoData && marriageFemaleInfoData.palaceStability">
                                <div class="marriage-energy-avatar-box box-high avatar-female">
                                    <div class="avatar-content clearfix">
                                        <div class="marriage-energy-avatar avatar-female"></div>
                                        <span class="marriage-energy-nickname">{{ marriageFemaleInfoData.name }}</span>
                                    </div>
                                    <div class="avatar-score">得分：<span class="score-text">{{ marriageFemaleInfoData.palaceStability.score }}</span></div>
                                </div>
                                <div class="marriage-content-info-bar-box">
                                    <div class="marriage-content-info-bar bar-female"><span class="bar-value" :style="'width: '+marriageFemaleInfoData.palaceStability.score+'%;'"></span></div>
                                </div>
                                <p class="marriage-content-c-p" v-for="text in marriageFemaleInfoData.palaceStability.des">{{ text }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">夫妻宫越稳定分越高，说明家宅越安宁，夫妻宫越活跃分越低，说明家里动静越大，但未必代表凶，也可能代表家里总有人出入，比如夫妻俩有人出差比较多，或者聚少离多。如果此项分数较低，则尽可能匹配此项分数较高的对象，更利于趋吉避凶。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 6、相处方式和谐度 -->
        <div id="mrgBox6" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>相处方式和谐度</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image9"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">相处方式和谐度是根据两个人主能量的契合情况来计算的，一般来说，分数越高越容易以一种令双方舒适的方式去爱护对方、支持对方。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageMergeInfoData.harmonyScore" class="marriage-content-c-content">
                        <div class="marriage-content-score-box">
                            <div class="marriage-content-score small">
                                <span class="score-num">{{ marriageMergeInfoData.harmonyScore.score }}<span class="score-text">分</span></span>
                            </div>
                        </div>
                        <p class="marriage-content-c-p" v-for="text in marriageMergeInfoData.harmonyScore.des">{{ text }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">在现实中我们也经常看到有很多夫妻经常以一种令对方不舒服的方式去爱或者关心对方，结果适得其反；所以分数较低，不代表凶，但要特别注意换位思考来及时调整，避免让对方心生不快。尤其男人要多长嘴巴，别闷葫芦，少些冷暴力。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 7、夫妻宫的匹配度 -->
        <div id="mrgBox7" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>夫妻宫的匹配度</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image10"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">夫妻宫的匹配至关重要，她代表着两个人共处一室能否安定和睦；如果匹配度较差，那么就要我们特别注意后天方面主动规避和改善了。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageMergeInfoData.palaceMatchResult" class="marriage-content-c-content">
                        <div class="marriage-content-score-box">
                            <div class="marriage-content-score small">
                                <span class="score-num">{{ marriageMergeInfoData.palaceMatchResult.score }}<span class="score-text">分</span></span>
                            </div>
                        </div>
                        <p class="marriage-content-c-p" v-for="text in marriageMergeInfoData.palaceMatchResult.des">{{ text }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">就算前面的测算分数再怎么低，此项的分数也能力挽狂澜，毕竟双方的夫妻宫是双方共同的家，而我们一天有很多时间都是在家中，家宅安宁则相安无事。如果夫妻宫匹配度不高，说明后天改进的空间较大，需要双方共同努力去改善；也可能代表着家中人容易出差多，聚少离多或者搬家较多，倒不绝对代表两人不能共处一室，但相比而言，容易生出矛盾或冲突，需要更加主动积极地沟通解决。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 8、整体生日能量契合度 -->
        <div id="mrgBox8" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>整体生日能量契合度</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image11"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">生日能量契合度是根据两个人能量场的契合情况来计算的，一般来说，分数越高越容易和睦共处，越容易进入谈婚论嫁阶段并修成正果。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageMergeInfoData.overallEnergyScore" class="marriage-content-c-content">
                        <div class="marriage-content-score-box">
                            <div class="marriage-content-score small">
                                <span class="score-num">{{ marriageMergeInfoData.overallEnergyScore.score }}<span class="score-text">分</span></span>
                            </div>
                        </div>
                        <p class="marriage-content-c-p" v-for="text in marriageMergeInfoData.overallEnergyScore.des">{{ text }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">凡事总有例外，如果分数不高那就多谈谈、多处处，再来看看适不适合长期发展；如果已经喜结连理了，那可以在未来留意一下多一些换位思考来迁就对方让双方的生活更和谐。整体契合度如果不高，说明二人心性、兴趣爱好等等差异较大，但现实情况是，多数成婚夫妻两个人的性格、兴趣、价值观都是有差异的；只不过需要留心的是，契合度越低越容易疏远或发生矛盾，有意识地去规避就可以化解。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 9、月老送上天长地久建议 -->
        <div id="mrgBox9" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>月老送上天长地久建议</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image8"></div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask1">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content marriage-content-c-content-bg">
                        <div class="marriage-content-c-content-box bg-male">
                            <div class="marriage-content-c-avatar">
                                <div class="info-avatar avatar-male"></div>
                            </div>
                            <p class="marriage-content-c-p" v-for="text in marriageMaleInfoData.analysis">{{ text }}</p>
                        </div>
                        <div class="marriage-content-c-content-box bg-female">
                            <div class="marriage-content-c-avatar">
                                <div class="info-avatar avatar-female"></div>
                            </div>
                            <p class="marriage-content-c-p" v-for="text in marriageFemaleInfoData.analysis">{{ text }}</p>
                        </div>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 10、未来12个月感情危机规避 -->
        <div id="mrgBox10" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>未来12个月感情危机规避</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image12"></div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask1">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageMergeInfoData.riskMonth" class="marriage-content-c-content">
                        <p class="marriage-content-c-p p-t5"><span class="marriage-content-c-title">男方注意时间：</span>{{ marriageMergeInfoData.riskMonth.manTime.join('、') }}</p>
                        <p class="marriage-content-c-p p-t5"><span class="marriage-content-c-title">女方注意时间：</span>{{ marriageMergeInfoData.riskMonth.feManTime.join('、') }}</p>
                        <p class="marriage-content-c-p" v-for="text in marriageMergeInfoData.riskMonth.des">{{ text }}</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 11、结束语 -->
        <div class="marriage-result-content-bottom">
            <div class="marriage-result-content-bottom-title">
                <span class="title-icon icon-left"></span>
                <span class="title-text">结束语</span>
                <span class="title-icon icon-right"></span>
            </div>
            <div class="marriage-result-content-bottom-text">
                <p>总之，人生也好，婚姻也好，她都像天气预报一样是一道虽未知结果但有规律的计算题，无论她的先天状况是好是坏，她都有最优解，而最终结果都是由我们在知己知彼知道以上情况的前提下进行书写，提前预知并适当调整、优化，最终达成双方婚姻家庭的幸福、美满！这也就是古人发明合婚的初衷和意义，而不要封建迷信地去因为看到分数不好而受到惊吓或者恐惧，而应该庆幸知道就可能主动趋利避害。</p>
                <p>最后祝天下有情人终成眷属，婚姻幸福美满到永久！</p>
            </div>
        </div>
        <!-- 12、提示解锁成功的弹框 -->
        <van-popup class="report-result-suc" v-bind:value="showPaySuc" @click-overlay="clickPayPop">
            <div class="report-result-suc-content">
                <img v-bind:src="sucGif" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import MarriageReportButton from './MarriageReportButton.vue'
import MarriageEnergyTwo from './MarriageEnergyTwo.vue';
import { CONFIG } from '../../modules/config'
import { MARRIAGE_DOM } from '../../modules/dom';
export default {
    name: 'MarriageReportTwoResult',
    components: { MarriageReportButton, MarriageEnergyTwo },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        marriageProductData() {
            return this.$store.state.pay.marriageProductData;
        },
        marriageFavorableInfoData() {
            return this.$store.state.marriage.marriageFavorableInfoData;
        },
        marriageData() {
            return this.$store.state.marriage.marriageData;
        },
        productData() {
            return this.$store.state.pay.marriageProductData[this.$store.state.marriage.marriageData.pid];
        },
        marriageMaleInfoData() {
            return this.$store.state.marriage.marriageMaleInfoData;
        },
        marriageFemaleInfoData() {
            return this.$store.state.marriage.marriageFemaleInfoData;
        },
        marriageMergeInfoData() {
            return this.$store.state.marriage.marriageMergeInfoData;
        },
    },
    data() {
        return {
            UTILS: UTILS,
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif'),
        }
    },
    mounted() {
        this.$bus.on('showMarriageReportSuc', this.showMarriageReportSuc);
        this.$bus.on('triggerReportTwoPay', this.clickPay);
    },
    destroyed() {
        this.$bus.off('showMarriageReportSuc', this.showMarriageReportSuc);
        this.$bus.off('triggerReportTwoPay', this.clickPay);
    },
    methods: {
        clickPay(params) {
            console.log('clickPay--------', this.productData.pid, this.marriageData.id)
            // 会员特权免费解锁
            if(this.userData && this.userData.vip >= 30) {
                this.$store.dispatch('marriage/vipUnlockMarriageReport', {
                    sucCb: ()=> {
                        this.showMarriageReportSuc();
                        this.$store.dispatch('marriage/resetMarriageData');
                        this.$store.dispatch('marriage/getMarriageInfoById', { rData: this.marriageData });
                    },
                    failCb: ()=> {
                        this.$toast('免费解锁失败，请稍后再试');
                    }
                })
                return;
            }

            var payType = CONFIG.platform == 'qq' ? 'wx_qr' : this.productData.payType[2];
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: this.productData.pid,         //支付项目id
                    ptype: payType,                    //支付方式
                    ext: this.marriageData.id          //支付的评测id
                },
                // mixParams: {
                //     pid: params.data.pid,
                //     product_name: params.data.title,
                //     price: params.data.price,
                //     from: 'generate_ai',
                // },
                sucCb: () => {
                    console.log('支付成功，更新合婚报告数据');
                    this.showMarriageReportSuc();
                    // 更新数据
                    this.$store.dispatch('marriage/resetMarriageData');
                    this.$store.dispatch('marriage/getMarriageInfoById', { rData: this.marriageData });

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: ()=> {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        },
        clickPayPop() {
            this.showPaySuc = false;
        },
        showMarriageReportSuc() {
            // 显示并定时隐藏支付成功提示
            this.showPaySuc = true;
            setTimeout(() => {
                this.showPaySuc = false;
                MARRIAGE_DOM.initMarriagePageHeightList();
                setTimeout(()=> {
                    MARRIAGE_DOM.bindMarriageScrollEvent();
                }, 20);
            }, 3000);
        },

    }
}
</script>